// action types
import { createRequestTypes } from "../../utils";

// Fetch archives
export const FETCH_ARCHIVES = createRequestTypes("FETCH_ARCHIVES");
export const FETCH_ARCHIVE_DETAIL = createRequestTypes("FETCH_ARCHIVE_DETAIL");

// Create/Update/Delete archive
export const UPLOAD_ARCHIVE = createRequestTypes("UPLOAD_ARCHIVE");
export const UPDATE_ARCHIVE = createRequestTypes("UPDATE_ARCHIVE");
export const DELETE_ARCHIVE = createRequestTypes("DELETE_ARCHIVE");
export const DOWNLOAD_ARCHIVE = createRequestTypes("DOWNLOAD_ARCHIVE");

// Storage stats
export const FETCH_STORAGE_STATS = createRequestTypes("FETCH_STORAGE_STATS");

// UI State
export const SET_ARCHIVE_FILTERS = 'SET_ARCHIVE_FILTERS';
export const CLEAR_ARCHIVE_DETAIL = 'CLEAR_ARCHIVE_DETAIL';
export const SET_SELECTED_ARCHIVE = 'SET_SELECTED_ARCHIVE';
export const SET_UPLOAD_DIALOG_OPEN = 'SET_UPLOAD_DIALOG_OPEN';

// ==================== ARCHIVES ====================

export const fetchArchivesRequest = (filters = {}) =>
    ({ type: FETCH_ARCHIVES.REQUEST, payload: filters });

export const fetchArchivesSuccess = (archives) =>
    ({ type: FETCH_ARCHIVES.SUCCESS, payload: archives });

export const fetchArchivesFailure = (error) =>
    ({ type: FETCH_ARCHIVES.FAILURE, payload: error });

export const fetchArchiveDetailRequest = (archiveId) =>
    ({ type: FETCH_ARCHIVE_DETAIL.REQUEST, payload: { archiveId } });

export const fetchArchiveDetailSuccess = (archive) =>
    ({ type: FETCH_ARCHIVE_DETAIL.SUCCESS, payload: archive });

export const fetchArchiveDetailFailure = (error) =>
    ({ type: FETCH_ARCHIVE_DETAIL.FAILURE, payload: error });

export const uploadArchiveRequest = (archiveData) =>
    ({ type: UPLOAD_ARCHIVE.REQUEST, payload: archiveData });

export const uploadArchiveSuccess = (archive) =>
    ({ type: UPLOAD_ARCHIVE.SUCCESS, payload: archive });

export const uploadArchiveFailure = (error) =>
    ({ type: UPLOAD_ARCHIVE.FAILURE, payload: error });

export const updateArchiveRequest = (archiveId, archiveData) =>
    ({ type: UPDATE_ARCHIVE.REQUEST, payload: { archiveId, archiveData } });

export const updateArchiveSuccess = (archive) =>
    ({ type: UPDATE_ARCHIVE.SUCCESS, payload: archive });

export const updateArchiveFailure = (error) =>
    ({ type: UPDATE_ARCHIVE.FAILURE, payload: error });

export const deleteArchiveRequest = (archiveId) =>
    ({ type: DELETE_ARCHIVE.REQUEST, payload: { archiveId } });

export const deleteArchiveSuccess = (archiveId) =>
    ({ type: DELETE_ARCHIVE.SUCCESS, payload: { archiveId } });

export const deleteArchiveFailure = (error) =>
    ({ type: DELETE_ARCHIVE.FAILURE, payload: error });

export const downloadArchiveRequest = (archiveId, fileName) =>
    ({ type: DOWNLOAD_ARCHIVE.REQUEST, payload: { archiveId, fileName } });

export const downloadArchiveSuccess = () =>
    ({ type: DOWNLOAD_ARCHIVE.SUCCESS });

export const downloadArchiveFailure = (error) =>
    ({ type: DOWNLOAD_ARCHIVE.FAILURE, payload: error });

// ==================== UI STATE ====================

export const setArchiveFilters = (filters) =>
    ({ type: SET_ARCHIVE_FILTERS, payload: filters });

export const clearArchiveDetail = () =>
    ({ type: CLEAR_ARCHIVE_DETAIL });

export const setSelectedArchive = (archive) =>
    ({ type: SET_SELECTED_ARCHIVE, payload: archive });

export const setUploadDialogOpen = (isOpen) =>
    ({ type: SET_UPLOAD_DIALOG_OPEN, payload: isOpen });

// ==================== STORAGE STATS ====================

export const fetchStorageStatsRequest = (organizationId) =>
    ({ type: FETCH_STORAGE_STATS.REQUEST, payload: { organizationId } });

export const fetchStorageStatsSuccess = (stats) =>
    ({ type: FETCH_STORAGE_STATS.SUCCESS, payload: stats });

export const fetchStorageStatsFailure = (error) =>
    ({ type: FETCH_STORAGE_STATS.FAILURE, payload: error });
